import {
  FormControlLabel as MuiFormControlLabel,
  FormControlLabelProps as MuiFormControlLabelProps,
} from '@material-ui/core';
import { Typography } from 'bento';
import { formControlLabelRoot, formControlLabelTextWrapper } from './formControlLabelCssDefs';
import React from 'react';

export type FormControlLabelProps = Omit<MuiFormControlLabelProps, 'labelPlacement'> & {
  /**
   * Text or custom element to include under the label text.
   */
  helperText?: React.ReactNode;
  /**
   * The position of the label text. Default is end.
   */
  labelPlacement?: 'start' | 'end';
  /**
   * Size of the control.
   */
  size?: 'small' | 'medium';
};

/**
 * Label component for Radio and Checkbox elements
 * First line of label text is vertically centered relative to the control height.
 * If the text wraps the control will stay centered with the first line.
 *
 * Custom label components will need to implement their own margin/padding
 *
 * Related Components: ui/Checkbox, ui/Radio, ui/FormCheckbox
 * @deprecated Deprecated — no pantry replacement available yet.
 * Migration: No direct pantry mapping — please reach out to the Design Systems team on Slack (e.g., #pantry-design-system) for assistance with a pantry replacement.
 */
export const FormControlLabel = React.forwardRef<HTMLLabelElement, FormControlLabelProps>(
  ({ className, control, helperText, size = 'medium', label, disabled, ...rest }, ref) => {
    const helperTextEl = helperText ? (
      typeof helperText === 'string' ? (
        <Typography variant="caption" color="subtle" mb={0.75}>
          {helperText}
        </Typography>
      ) : (
        helperText
      )
    ) : null;

    const labelTextEl = label ? (
      typeof label === 'string' ? (
        <Typography variant="body" color={disabled ? 'disabled' : 'default'}>
          {label}
        </Typography>
      ) : (
        label
      )
    ) : null;

    return (
      <MuiFormControlLabel
        css={formControlLabelRoot}
        className={className}
        control={React.cloneElement(control, { size })}
        label={
          <div css={formControlLabelTextWrapper}>
            {labelTextEl}
            {helperTextEl}
          </div>
        }
        ref={ref}
        disabled={disabled}
        {...rest}
      />
    );
  }
);
